import React from 'react';
import styled from 'styled-components';
import { FieldError } from 'react-hook-form';

import { classList } from '@/helpers';

interface InputErrorMessageProps {
  error?: FieldError;
  touched?: boolean;
  className?: string;
  showError?: boolean;
}

const InputErrorMessage = ({ error, touched, className, showError }: InputErrorMessageProps): React.ReactElement => {
  return (
    <ErrorMessage className={className}>
      {(error && touched) || error?.type === 'api' || (showError && error) ? error.message : ''}
    </ErrorMessage>
  );
};

const ErrorMessage = styled.div.attrs(props => ({
  className: classList(props.className, 'h-3'),
  ...props,
}))`
  min-height: 24px;
  padding-top: 4px;
  font-size: 12px;
  color: #dc3545;
`;

export { InputErrorMessage };
